import { render, staticRenderFns } from "./DealLeadInfo.vue?vue&type=template&id=65c58ff2"
import script from "./DealLeadInfo.vue?vue&type=script&lang=js"
export * from "./DealLeadInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports